// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCPjcgq-4yCI_as97D686ui8anCA3At58A",
  authDomain: "gts-app-d2e95.firebaseapp.com",
  databaseURL: "https://gts-app-d2e95-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "gts-app-d2e95",
  storageBucket: "gts-app-d2e95.appspot.com",
  messagingSenderId: "773620863887",
  appId: "1:773620863887:web:21237e0acec8a2bc0031fa"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app)